<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="DED" id="_idParaDest-2"><a id="page_vii">For Mathew,</a></p><a id="page_vii">
<p class="DEDI">Congratulations to my 2017 graduate!</p>
</a></div><a id="page_vii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?d2944d6a